import React, { FC } from "react";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const CircleInfo: FC<
  JSX.IntrinsicAttributes & Omit<FontAwesomeIconProps, "icon">
> = (props) => <FontAwesomeIcon icon={faCircleInfo} {...props} />;
